module.exports = __webpack_public_path__ + "media/images/country_flags/ls-1d4d1937fb004848c0b308a3def342f2.png";